import React, { useEffect } from "react";
import { webcamInstance } from "../Artist/js/Lotus-Webcam";
import { createLotusRender } from "../Artist/js/Lotus-Render";
import {
  LotusRenderWrapper,
  LotusContainer,
} from "../styles/components/Global/Artwork";

const LotusRender = () => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      import("p5").then(p5 => {
        let webcamSketch = null;
        let renderSketch = null;

        webcamSketch = new p5.default(p => webcamInstance(p));
        renderSketch = new p5.default(
          p => createLotusRender(p, webcamSketch),
          "lotus_render"
        );
      });
    }
  }, []);

  return (
    <LotusRenderWrapper>
      <LotusContainer>
        <div id="lotus_render"></div>
      </LotusContainer>
    </LotusRenderWrapper>
  );
};

export default LotusRender;
